export default "__VITE_ASSET__CJR8RLPq__"